import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Outlet, useLocation, useNavigate } from 'react-router';
import RightSidebar from 'components/Layout/RightSidebar';
import { useDispatch, useSelector } from 'react-redux';
import usePermissionCheck from 'utils/hooks/usePermissionCheck';
import CentralizedSpinner from 'components/CentralizedSpinner';
import ControlPanel from 'components/Flux/Automatic/ControlPanel';
import TabbedPage from 'components/TabbedPage';
import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import SectionTabs, { SectionTabItem } from 'components/Layout/MobileShell/SectionTabs';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import shortenedTabPath from 'helper/shortenedTabPath';
import useIsMobile from 'utils/hooks/useIsMobile';
import { openRight, selectOpen } from 'redux/reducers/sidebarsReducer';
import { selectFluxAutomaticLayoutCurrentTab } from 'redux/reducers/fluxAutomaticLayoutReducer';

const MOBILE_TABS: SectionTabItem[] = [
  { title: 'Clássico', path: '/flux/automatic/classic' },
  { title: 'Base Diária', path: '/flux/automatic' },
  { title: 'Base Mensal', path: '/flux/automatic/monthly' },
  { title: 'RVX Multicenário', path: '/flux/automatic/revision' },
  { title: 'RVX Unicenário', path: '/flux/automatic/unicenario' },
  { title: 'Vobs DSS / DC', path: '/flux/automatic/vobs' },
];

export default function FluxAutomaticWrapper() {
  const dispatch = useDispatch();
  const openSide = useSelector(selectOpen);
  const currentTab = useSelector(selectFluxAutomaticLayoutCurrentTab);
  const keySaved = usePermissionCheck('prevs-automatico');
  const isMobile = useIsMobile();
  const location = useLocation();
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);
  const hideSidebar = currentTab === 'vobs';
  let contentWidth: string;
  let panelWidth: string;
  if (hideSidebar) {
    contentWidth = '100%';
    panelWidth = '0%';
  } else if (openSide === 'right') {
    contentWidth = '66.66666667%';
    panelWidth = '33.33333333%';
  } else {
    contentWidth = '95%';
    panelWidth = '5%';
  }

  useEffect(() => {
    if (keySaved && !isMobile && currentTab !== 'vobs') dispatch(openRight());
  }, [dispatch, keySaved, isMobile, currentTab]);

  if (!keySaved) {
    return <CentralizedSpinner />;
  }

  if (isMobile) {
    const activeTab = MOBILE_TABS.find(
      (tab) => tab.path === shortenedTabPath(location.pathname),
    );

    return (
      <>
        <MobileSectionHeader
          backLabel="Estudos Automáticos"
          title={activeTab?.title ?? ''}
          onBack={() => navigate('/flux')}
          onAvatarClick={() => setMoreOpen(true)}
        />
        <SectionTabs tabs={MOBILE_TABS} />
        <Outlet />
        <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
      </>
    );
  }

  return (
    <>
      <Row>
        <Col className="md-6">
          <h1 className="mb-3">ESTUDOS AUTOMÁTICOS</h1>
        </Col>
      </Row>
      <Row style={{ flexWrap: 'nowrap', paddingBottom: '3.3125rem' }}>
        <Col className="flex-fill overflow-hidden" style={{ maxWidth: contentWidth }}>
          <TabbedPage>
            <TabbedPage.Tab title="CLÁSSICO" path="/flux/automatic/classic" />
            <TabbedPage.Tab title="BASE DIÁRIA" path="/flux/automatic" />
            <TabbedPage.Tab title="BASE MENSAL" path="/flux/automatic/monthly" />
            <TabbedPage.Tab title="RVX MULTICENÁRIO" path="/flux/automatic/revision" />
            <TabbedPage.Tab title="RVX UNICENÁRIO" path="/flux/automatic/unicenario" />
            <TabbedPage.Tab title="VOBS DSS / DC" path="/flux/automatic/vobs" />
          </TabbedPage>
        </Col>
        {!hideSidebar && (
          <Col style={{ maxWidth: panelWidth }}>
            <RightSidebar>
              <ControlPanel />
            </RightSidebar>
          </Col>
        )}
      </Row>
      <div className="bottom-bar" />
    </>
  );
}
